import React, { forwardRef } from 'react';
import { StyledAppBarButton } from './styled';
export const AppBarButton = forwardRef(function AppBarButton({ children, selected, ...props }, ref) {
    return (React.createElement(StyledAppBarButton, { ref: ref, "$selected": selected, ...props }, children));
});
